export const config = {
  apiUrl: "https://api.fomocinemas.com.au/api/",
  // apiUrl: "https://nova.weavolve.com/api/",
};
